import { Actions as AppActions } from '../actions/app';
import history from '../history';
import { LocalStorageKey } from '../utils/localStorage';
import { cleanupStompMiddleware } from './streamStompMiddleware';

const getToken = (): string | null => {
  return window.localStorage.getItem(LocalStorageKey.TOKEN);
};

const isValidToken = (authToken?: string | null): authToken is string => {
  if (!authToken) return false;

  const normalizedToken = authToken.trim().toLowerCase();

  return (
    normalizedToken !== '' &&
    normalizedToken !== 'undefined' &&
    normalizedToken !== 'null'
  );
};

const setToken = (authToken: string) => {
  window.localStorage.setItem(LocalStorageKey.TOKEN, authToken);
};

const removeToken = () => {
  window.localStorage.removeItem(LocalStorageKey.TOKEN);
};

const updateToken = (store: any, accessToken: string): boolean => {
  if (!isValidToken(accessToken)) {
    removeToken();
    return false;
  }

  setToken(accessToken);

  store.dispatch({
    type: AppActions.ACCESS_TOKEN_UPDATED,
    accessToken: accessToken,
  });

  return true;
};

const authMiddleware = store => next => action => {
  switch (action.type) {
    case AppActions.INIT:
      const accessToken = getToken();

      if (isValidToken(accessToken)) {
        store.dispatch({
          type: AppActions.ACCESS_TOKEN_UPDATED,
          accessToken,
        });
      } else if (accessToken !== null) {
        removeToken();
      }
      break;

    case AppActions.INIT_WITH_TOKEN:
    case AppActions.LOGIN_SUCCESS:
    case AppActions.RESET_PASSWORD_SUCCESS:
      if (updateToken(store, action.data.accessToken)) {
        history.push('/', {});
        window.location.reload();
      }
      break;

    case AppActions.CHANGE_ORGANIZATION_SUCCESS:
      cleanupStompMiddleware();
      if (updateToken(store, action.data.accessToken)) {
        history.push('/');
        window.location.reload();
      }
      break;

    case AppActions.LOGOUT:
      removeToken();
      cleanupStompMiddleware();
      break;

    default:
      break;
  }

  next(action);
};

export default authMiddleware;
